import { useState, useCallback } from 'react';

const usePerformanceBar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({});

  const showPerformanceBar = useCallback((performanceData) => {
    setData(performanceData);
    setIsVisible(true);
  }, []);

  const hidePerformanceBar = useCallback(() => {
    setIsVisible(false);
  }, []);

  const updateData = useCallback((newData) => {
    setData(prev => ({ ...prev, ...newData }));
  }, []);

  return {
    isVisible,
    data,
    showPerformanceBar,
    hidePerformanceBar,
    updateData
  };
};

export default usePerformanceBar;